<template>
  <v-data-table
    :headers="headers"
    :items="formattedItems"
    must-sort
    :no-data-text="$t('texts.employee.noEntries')"
    :no-results-text="$t('texts.noSearchEntries')"
    :footer-props="{ itemsPerPageText: $t('texts.rowsPerPage')}"
    class="elevation-0"
    :loading="loading"
    :hide-default-footer="items.length <= 5 || loading"
  >
    <template v-slot:item.actions="{ item }">
      <v-btn
        v-if="item.renewal_checked_on === null"
        @click="openEditEmployeeReEnterDialog(item)"
        small
        color="primary"
      >
        {{ $t('texts.employeeReEnter.label') }}
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'TableEmployeeReEnter',
  props: {
    loading: {
      type: Boolean,
    },
    items: {
      type: Array,
    },
  },
  computed: {
    headers() {
      const headers = [
        {
          text: `${this.$i18n.t('texts.firstName')} ${this.$i18n.t('texts.lastName')}`,
          value: 'formattedName',
          align: 'left',
        },
        { text: this.$i18n.t('texts.insertJobtitle'), value: 'title', align: 'left' },
        { text: this.$i18n.t('texts.startOfWork'), value: 'formattedStartDate', align: 'left' },
        { text: this.$i18n.t('texts.endOfWork'), value: 'formattedEndDate', align: 'left' },
        { text: '', value: 'actions', align: 'right' },
      ];
      return headers;
    },
    formattedItems() {
      if (this.items.length > 0) {
        return this.items.map((item) => {
          const formattedName = `${item.employee_first_name} ${item.employee_last_name}`;
          const formattedStartDate = this.$options.filters.formatDateShort(item.start_date);
          const formattedEndDate = this.$options.filters.formatDateShort(item.end_date);
          const formattedItem = {
            ...item,
            formattedName,
            formattedStartDate,
            formattedEndDate,
          };
          return formattedItem;
        });
      }
      return [];
    },
  },
  methods: {
    openEditEmployeeReEnterDialog(item) {
      this.$eventBus.$emit('show-edit-employee-reenter-dialog', item);
    },
  },
};
</script>
